const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the  totals-chart directive to display the chart for Existing X v New X
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Overview the resource defined to get Overview queries
 * @argument {Resource} Analyze the resource defined to get Analyze data
 */
app.directive('userAssignmentsChart', [
  'Application', 'Authorization',
  'Assignments',
  '$translate',
  '$q',
  function (Application, Authorization, Assignments, $translate, $q) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        for: '@',
        headline: '@',
        action: '=?',
        of: '=?',
      },
      template: require('../../../templates/directives/overview/user-assignments-chart.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.authtoken = Authorization.getAuthToken();
          self.user = self.authtoken.user;
          self.for = '';
          self.headline = 'Headline';
          self.labels = [];
          self.showChart = true;
          self.noAssignmentsLabel = 'modules.userAssignmentsChart.noAssignments';

          self.toggleData = function () {
            self.showAllTime = !self.showAllTime;

            if (self.showAllTime) {
              self.data = [self.openAssignments, self.completedAllTime];
              self.checkboxLabel = 'modules.userAssignmentsChart.checkboxLabelLastThirty';
              self.headerLabel = 'modules.userAssignmentsChart.checkboxLabelAllTime';
            } else {
              self.data = [self.openAssignments, self.completedLastThiry];
              self.checkboxLabel = 'modules.userAssignmentsChart.checkboxLabelAllTime';
              self.headerLabel = 'modules.userAssignmentsChart.checkboxLabelLastThirty';
            }
          };

          // chart config
          $translate(['modules.userAssignmentsChart.openAssignments', 'modules.userAssignmentsChart.completedAssignments']).then(function (translations) {
            self.labels = [translations['modules.userAssignmentsChart.openAssignments'], translations['modules.userAssignmentsChart.completedAssignments']];
          });

          self.getColors = function () {
            return Application.chartColors;
          };

          self.colors = self.getColors();

          self.initialize = function () {
            self.headline = $scope.headline;
            self.showAllTime = false;
            self.checkboxLabel = 'modules.userAssignmentsChart.checkboxLabelAllTime';
            self.headerLabel = 'modules.userAssignmentsChart.checkboxLabelLastThirty';

            $q.all([
              Assignments.find({
                assignee: self.user._id,
                completed_date: '$gte,date-' + moment().subtract(30, 'days').format('MM-DD-YY'),
                fields: 'assignee,completed,completed_date',
              }).$promise,
              Assignments.find({
                assignee: self.user._id,
                fields: 'assignee,completed,completed_date',
              }).$promise,
            ])
              .then(function (results) {
                if (results[1].length === 0) {
                  self.showChart = false;
                } else {
                  self.completedLastThiry = results[0].length;
                  self.completedAllTime = results[1].filter((result) => result.completed).length;
                  self.openAssignments = results[1].filter((result) => !result.completed).length;
                  self.data = [self.openAssignments, self.completedLastThiry];
                }
              })
              .catch(function (error) {
                console.log('Error: ', error);
                self.showChart = false;
              });
          };
          self.initialize();
        },
      ],
      controllerAs: 'assignmentsChart',
    };
  },
]);
